<template>
  <v-data-table :headers="headers" :items="allPayments" :items-per-page="10000" class="elevation-1" hide-default-footer v-if="allPayments.length">
    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="text-left"><v-icon color="green darken-1" small>fa fa-check-circle</v-icon></td>
          <td class="text-left">{{ item.datavencimento | moment("DD/MM/YYYY") }}</td>
          <td class="text-left">{{ item.valordocumento | formatPrice }}</td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
  <p v-else> Você não efetuou nenhum pagamentos nos últimos 12 meses.</p>
</template>
<script>
export default {
  data () {
    return {
      headers: [
        { text: "", value: "situacao", sortable: false },
        { text: "Vencimento", value: "datavencimento", sortable: false },
        { text: "Valor", value: "valordocumento", sortable: false }
      ],
    }
  },
  props: {
    allPayments: Array
  }
}
</script>
